@if (formStatus) {
  @if (formStatus.isSaved()) {
    <div>Vše uloženo.</div>
  }
  @if (formStatus.isSaving()) {
    <div>Ukládám...</div>
  }
  @if (formStatus.isNotOk()) {
    <div>Asistenci nebylo možné uložit.</div>
  }
}
